'use client';
import Avo, { OverlayStepValueType } from '@susu/custom-made/Avo';
import { useEffect, useState } from 'react';
import Panel, { PanelSize, PanelType } from '../../panel/panel';
import { OnBoardingPanel } from '../onBoardingPanel/onBoardingPanel';
import useNavigationContext from '@susu/custom-made/providers/hooks/useNavigationContext';
import useUserContext from '@susu/custom-made/providers/hooks/useUserContext';
import { useAvo } from '@susu/custom-made/hooks/useAvo';
import cn from 'classnames';
import { useI18N } from '@susu/i18n/client';
import { useFeatureIsOn } from '@susu/feature-flags/react';
import { FEATURE_TOGGLES } from '@susu/custom-made/feature-flags/featureToggles';

const { ENABLE_AVO_TRACKING } = FEATURE_TOGGLES;

export const OnBoardingContainer = () => {
  const { t } = useI18N();
  const { section } = useNavigationContext();
  const [currentStep, setCurrentStep] = useState<number>(0);
  const { product } = useUserContext();
  const { getAvoStandardEventParams } = useAvo();
  const isAvoTrackingEnabled = useFeatureIsOn(ENABLE_AVO_TRACKING);
  const [isShown, setIsShown] = useState<boolean>(false);
  const visitedStorageName = 'cm_visited_products';
  const onBoardingTexts = [
    t('onBoarding.title'),
    t('onBoarding.step1'),
    t('onBoarding.step2'),
    t('onBoarding.step3'),
    t('onBoarding.step4'),
  ];

  const startDesignClick = () => {
    setIsShown(false);
    if (isAvoTrackingEnabled) {
      Avo.customMadeDesigningStarted({
        ...getAvoStandardEventParams(section!),
      });
    }
  };

  const overlayStep = (stepNo: number) => {
    switch (stepNo) {
      case 0:
        return 'intro';
      case 1:
        return 'fabric';
      case 2:
        return 'style';
      case 3:
        return 'personalise';
      case 4:
        return 'fit';
      default:
        return 'intro';
    }
  };

  const overlayExitClick = () => {
    setIsShown(false);
    if (isAvoTrackingEnabled) {
      Avo.customMadeOverlayExited({
        ...getAvoStandardEventParams(section!),
        overlayStep: overlayStep(currentStep) as OverlayStepValueType,
      });
    }
  };

  useEffect(() => {
    const currentProduct = product as string;
    const visitedProductStorage = localStorage.getItem(visitedStorageName);
    if (!visitedProductStorage || visitedProductStorage.split(',').indexOf(currentProduct) === -1) {
      setIsShown(true);

      let visitedProductArray = [currentProduct];
      if (visitedProductStorage) {
        visitedProductArray = [...visitedProductStorage.split(','), ...visitedProductArray];
      }
      localStorage.setItem(visitedStorageName, visitedProductArray.join(','));
    }
  }, []);

  return (
    <div className={cn(isShown && 'relative z-101')}>
      <Panel
        isActive={isShown}
        closeClick={overlayExitClick}
        panelSize={PanelSize.Full}
        hasCloseBtn={true}
        withOverlay={true}
        panelType={PanelType.MiddleScreen}
        testIdSubfix="onboarding"
        zIndex={101}
      >
        {isShown && (
          <OnBoardingPanel
            title={onBoardingTexts}
            ctaClick={startDesignClick}
            ctaText={t('onBoarding.startDesigning')}
            stepAmount={5}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            overlayStep={overlayStep}
          />
        )}
      </Panel>
    </div>
  );
};
